var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { AccordionItemBase } from './components/AccordionItemBase';
const StyledAccordionWrapper = styled.div `
  ${({ $disableContainer, theme: { colors, space } }) => `
    ${!$disableContainer
    ? `
          border-radius: 4px;
          background-color: ${colors['light-gray']};
          border: 1px solid ${colors['slate-2']};
          border-bottom: ${space.none};
          box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.16),
          0 5px 8px -4px rgba(0, 0, 0, 0.16);`
    : ''}
  `}
`;
export const Accordion = (_a) => {
    var { disableContainer = false, allowMultipleExpanded = false, items, dataTestId } = _a, rest = __rest(_a, ["disableContainer", "allowMultipleExpanded", "items", "dataTestId"]);
    const preexpandedInitialState = items.reduce((prev, curr, index) => {
        return Object.assign(Object.assign({}, prev), { [index]: curr.isOpenOnMount });
    }, {});
    const [expandedStateByIndex, setExpandedByIndex] = React.useState(preexpandedInitialState);
    const onExpandedChange = (index, expanded) => {
        if (allowMultipleExpanded) {
            setExpandedByIndex(Object.assign(Object.assign({}, expandedStateByIndex), { [index]: expanded }));
        }
        else {
            // Set all to false
            const expandedStateAllFalse = Object.keys(expandedStateByIndex).reduce((prev, curr) => (Object.assign(Object.assign({}, prev), { [curr]: false })), {});
            // Add the one being expanded
            setExpandedByIndex(Object.assign(Object.assign({}, expandedStateAllFalse), { [index]: expanded }));
        }
    };
    return (React.createElement("div", Object.assign({ "data-testid": dataTestId }, rest),
        React.createElement(StyledAccordionWrapper, { "$disableContainer": disableContainer }, items.map((item, index) => (React.createElement(AccordionItemBase, { heading: item.heading, description: item.description, isExpanded: expandedStateByIndex[index], onExpandedChange: (expanded) => onExpandedChange(index, expanded), 
            // eslint-disable-next-line react/no-array-index-key
            key: item.itemId != null ? item.itemId : index, panel: item.panel, disableContainer: disableContainer, accordionItemKey: item.itemId != null ? item.itemId : index, clickEventName: item.clickEventName, dataTracking: item.dataTracking, ariaDescribedBy: item.ariaDescribedBy || undefined, onHeaderClick: item.onHeaderClick }))))));
};
//# sourceMappingURL=Accordion.js.map